import UnderlineMarkPlugin from './UnderlineMarkPlugin';

export default UnderlineMarkPlugin;
